var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYurumeifavicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    contentScriptType: "text/ecmascript",
    width: 82.5,
    zoomAndPan: "magnify",
    contentStyleType: "text/css",
    viewBox: "0 0 82.5 82.499998",
    height: 82.499998,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: "100%",
    id: "filter-remove-color",
    xlinkShow: "other"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2 69 L 82.003906 69 L 82.003906 82.003906 L 2 82.003906 Z M 2 69 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 87.421875 47.683594 L 15.167969 83.617188 L -2.902344 47.28125 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 105.699219 84.4375 L 20.496094 126.808594 L -15.847656 53.71875 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 38 69 L 82.003906 69 L 82.003906 82.003906 L 38 82.003906 Z M 38 69 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 87.421875 47.683594 L 15.167969 83.617188 L -2.902344 47.28125 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 105.699219 84.4375 L 20.496094 126.808594 L -15.847656 53.71875 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 73.476562 61.972656 L 87.972656 91.132812 L 49.113281 110.457031 L 34.613281 81.296875 Z M 73.476562 61.972656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 63.738281 100.394531 C 55.773438 100.9375 48.121094 94.9375 42.847656 91.476562 C 41.671875 90.773438 40.40625 90.316406 39.050781 90.105469 C 38.109375 87.722656 37.972656 85.292969 38.640625 82.824219 C 39.984375 82.457031 41.207031 81.851562 42.308594 81 C 47.101562 76.90625 53.78125 70.085938 61.644531 69.566406 C 72.945312 68.792969 82.566406 75.085938 83.160156 83.597656 C 83.757812 92.105469 75.042969 99.628906 63.738281 100.394531 Z M 63.738281 100.394531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 73 69 L 82.003906 69 L 82.003906 82.003906 L 73 82.003906 Z M 73 69 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 87.421875 47.683594 L 15.167969 83.617188 L -2.902344 47.28125 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 105.699219 84.4375 L 20.496094 126.808594 L -15.847656 53.71875 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 73.476562 61.972656 L 87.972656 91.132812 L 49.113281 110.457031 L 34.613281 81.296875 Z M 73.476562 61.972656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 63.738281 100.394531 C 55.773438 100.9375 48.121094 94.9375 42.847656 91.476562 C 41.671875 90.773438 40.40625 90.316406 39.050781 90.105469 C 38.109375 87.722656 37.972656 85.292969 38.640625 82.824219 C 39.984375 82.457031 41.207031 81.851562 42.308594 81 C 47.101562 76.90625 53.78125 70.085938 61.644531 69.566406 C 72.945312 68.792969 82.566406 75.085938 83.160156 83.597656 C 83.757812 92.105469 75.042969 99.628906 63.738281 100.394531 Z M 63.738281 100.394531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 56 69 L 69 69 L 69 82.003906 L 56 82.003906 Z M 56 69 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 87.421875 47.683594 L 15.167969 83.617188 L -2.902344 47.28125 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 105.699219 84.4375 L 20.496094 126.808594 L -15.847656 53.71875 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 73.476562 61.972656 L 87.972656 91.132812 L 49.113281 110.457031 L 34.613281 81.296875 Z M 73.476562 61.972656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 63.738281 100.394531 C 55.773438 100.9375 48.121094 94.9375 42.847656 91.476562 C 41.671875 90.773438 40.40625 90.316406 39.050781 90.105469 C 38.109375 87.722656 37.972656 85.292969 38.640625 82.824219 C 39.984375 82.457031 41.207031 81.851562 42.308594 81 C 47.101562 76.90625 53.78125 70.085938 61.644531 69.566406 C 72.945312 68.792969 82.566406 75.085938 83.160156 83.597656 C 83.757812 92.105469 75.042969 99.628906 63.738281 100.394531 Z M 63.738281 100.394531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 40 69 L 53 69 L 53 82.003906 L 40 82.003906 Z M 40 69 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 87.421875 47.683594 L 15.167969 83.617188 L -2.902344 47.28125 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 105.699219 84.4375 L 20.496094 126.808594 L -15.847656 53.71875 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 73.476562 61.972656 L 87.972656 91.132812 L 49.113281 110.457031 L 34.613281 81.296875 Z M 73.476562 61.972656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 63.738281 100.394531 C 55.773438 100.9375 48.121094 94.9375 42.847656 91.476562 C 41.671875 90.773438 40.40625 90.316406 39.050781 90.105469 C 38.109375 87.722656 37.972656 85.292969 38.640625 82.824219 C 39.984375 82.457031 41.207031 81.851562 42.308594 81 C 47.101562 76.90625 53.78125 70.085938 61.644531 69.566406 C 72.945312 68.792969 82.566406 75.085938 83.160156 83.597656 C 83.757812 92.105469 75.042969 99.628906 63.738281 100.394531 Z M 63.738281 100.394531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 66 69 L 74 69 L 74 76 L 66 76 Z M 66 69 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 87.421875 47.683594 L 15.167969 83.617188 L -2.902344 47.28125 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 105.699219 84.4375 L 20.496094 126.808594 L -15.847656 53.71875 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 73.476562 61.972656 L 87.972656 91.132812 L 49.113281 110.457031 L 34.613281 81.296875 Z M 73.476562 61.972656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 63.738281 100.394531 C 55.773438 100.9375 48.121094 94.9375 42.847656 91.476562 C 41.671875 90.773438 40.40625 90.316406 39.050781 90.105469 C 38.109375 87.722656 37.972656 85.292969 38.640625 82.824219 C 39.984375 82.457031 41.207031 81.851562 42.308594 81 C 47.101562 76.90625 53.78125 70.085938 61.644531 69.566406 C 72.945312 68.792969 82.566406 75.085938 83.160156 83.597656 C 83.757812 92.105469 75.042969 99.628906 63.738281 100.394531 Z M 63.738281 100.394531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 67 74 L 75 74 L 75 82 L 67 82 Z M 67 74 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 87.421875 47.683594 L 15.167969 83.617188 L -2.902344 47.28125 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 105.699219 84.4375 L 20.496094 126.808594 L -15.847656 53.71875 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 73.476562 61.972656 L 87.972656 91.132812 L 49.113281 110.457031 L 34.613281 81.296875 Z M 73.476562 61.972656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 63.738281 100.394531 C 55.773438 100.9375 48.121094 94.9375 42.847656 91.476562 C 41.671875 90.773438 40.40625 90.316406 39.050781 90.105469 C 38.109375 87.722656 37.972656 85.292969 38.640625 82.824219 C 39.984375 82.457031 41.207031 81.851562 42.308594 81 C 47.101562 76.90625 53.78125 70.085938 61.644531 69.566406 C 72.945312 68.792969 82.566406 75.085938 83.160156 83.597656 C 83.757812 92.105469 75.042969 99.628906 63.738281 100.394531 Z M 63.738281 100.394531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 67 80 L 75 80 L 75 82.003906 L 67 82.003906 Z M 67 80 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 87.421875 47.683594 L 15.167969 83.617188 L -2.902344 47.28125 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 105.699219 84.4375 L 20.496094 126.808594 L -15.847656 53.71875 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 73.476562 61.972656 L 87.972656 91.132812 L 49.113281 110.457031 L 34.613281 81.296875 Z M 73.476562 61.972656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 63.738281 100.394531 C 55.773438 100.9375 48.121094 94.9375 42.847656 91.476562 C 41.671875 90.773438 40.40625 90.316406 39.050781 90.105469 C 38.109375 87.722656 37.972656 85.292969 38.640625 82.824219 C 39.984375 82.457031 41.207031 81.851562 42.308594 81 C 47.101562 76.90625 53.78125 70.085938 61.644531 69.566406 C 72.945312 68.792969 82.566406 75.085938 83.160156 83.597656 C 83.757812 92.105469 75.042969 99.628906 63.738281 100.394531 Z M 63.738281 100.394531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 50 69 L 58 69 L 58 77 L 50 77 Z M 50 69 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 87.421875 47.683594 L 15.167969 83.617188 L -2.902344 47.28125 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 105.699219 84.4375 L 20.496094 126.808594 L -15.847656 53.71875 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 73.476562 61.972656 L 87.972656 91.132812 L 49.113281 110.457031 L 34.613281 81.296875 Z M 73.476562 61.972656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 63.738281 100.394531 C 55.773438 100.9375 48.121094 94.9375 42.847656 91.476562 C 41.671875 90.773438 40.40625 90.316406 39.050781 90.105469 C 38.109375 87.722656 37.972656 85.292969 38.640625 82.824219 C 39.984375 82.457031 41.207031 81.851562 42.308594 81 C 47.101562 76.90625 53.78125 70.085938 61.644531 69.566406 C 72.945312 68.792969 82.566406 75.085938 83.160156 83.597656 C 83.757812 92.105469 75.042969 99.628906 63.738281 100.394531 Z M 63.738281 100.394531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 51 75 L 58 75 L 58 82.003906 L 51 82.003906 Z M 51 75 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 87.421875 47.683594 L 15.167969 83.617188 L -2.902344 47.28125 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-45"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 105.699219 84.4375 L 20.496094 126.808594 L -15.847656 53.71875 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-46"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 73.476562 61.972656 L 87.972656 91.132812 L 49.113281 110.457031 L 34.613281 81.296875 Z M 73.476562 61.972656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-47"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 63.738281 100.394531 C 55.773438 100.9375 48.121094 94.9375 42.847656 91.476562 C 41.671875 90.773438 40.40625 90.316406 39.050781 90.105469 C 38.109375 87.722656 37.972656 85.292969 38.640625 82.824219 C 39.984375 82.457031 41.207031 81.851562 42.308594 81 C 47.101562 76.90625 53.78125 70.085938 61.644531 69.566406 C 72.945312 68.792969 82.566406 75.085938 83.160156 83.597656 C 83.757812 92.105469 75.042969 99.628906 63.738281 100.394531 Z M 63.738281 100.394531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 51 81 L 59 81 L 59 82.003906 L 51 82.003906 Z M 51 81 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 87.421875 47.683594 L 15.167969 83.617188 L -2.902344 47.28125 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-50"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 105.699219 84.4375 L 20.496094 126.808594 L -15.847656 53.71875 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-51"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 73.476562 61.972656 L 87.972656 91.132812 L 49.113281 110.457031 L 34.613281 81.296875 Z M 73.476562 61.972656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 63.738281 100.394531 C 55.773438 100.9375 48.121094 94.9375 42.847656 91.476562 C 41.671875 90.773438 40.40625 90.316406 39.050781 90.105469 C 38.109375 87.722656 37.972656 85.292969 38.640625 82.824219 C 39.984375 82.457031 41.207031 81.851562 42.308594 81 C 47.101562 76.90625 53.78125 70.085938 61.644531 69.566406 C 72.945312 68.792969 82.566406 75.085938 83.160156 83.597656 C 83.757812 92.105469 75.042969 99.628906 63.738281 100.394531 Z M 63.738281 100.394531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2 71 L 41 71 L 41 82.003906 L 2 82.003906 Z M 2 71 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 87.421875 47.683594 L 15.167969 83.617188 L -2.902344 47.28125 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-55"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 105.699219 84.4375 L 20.496094 126.808594 L -15.847656 53.71875 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-0"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-remove-color)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -8.25,
    width: 99,
    fill: "rgb(0%, 0%, 0%)",
    y: -8.25,
    height: 98.999997,
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2 11 L 37 11 L 37 11.003906 L 2 11.003906 Z M 2 11 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-57"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 67.351562 -59.652344 L 85.421875 -23.316406 L 13.167969 12.617188 L -4.902344 -23.71875 Z M 67.351562 -59.652344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-58"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 67.351562 -59.652344 L 103.699219 13.4375 L 18.496094 55.808594 L -17.847656 -17.28125 Z M 67.351562 -59.652344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-59"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 39,
    y: 0,
    height: 12
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 11 19 L 76 19 L 76 79 L 11 79 Z M 11 19 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-61"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 87.421875 47.683594 L 15.167969 83.617188 L -2.902344 47.28125 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 105.699219 84.4375 L 20.496094 126.808594 L -15.847656 53.71875 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 37 19 L 76 19 L 76 56 L 37 56 Z M 37 19 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 87.421875 47.683594 L 15.167969 83.617188 L -2.902344 47.28125 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-65"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 105.699219 84.4375 L 20.496094 126.808594 L -15.847656 53.71875 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 68.71875 13.421875 L 82.976562 42.09375 L 42.660156 62.144531 L 28.402344 33.472656 Z M 68.71875 13.421875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-67"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 67.808594 48.773438 C 61.859375 54.105469 52.136719 54.078125 45.859375 54.59375 C 44.5 54.761719 43.222656 55.179688 42.023438 55.847656 C 40.984375 55.238281 40.0625 54.484375 39.261719 53.582031 C 38.402344 52.621094 37.722656 51.542969 37.21875 50.355469 C 38.0625 49.238281 38.660156 48 39.011719 46.644531 C 40.273438 40.472656 41.339844 30.984375 47.195312 25.738281 C 55.636719 18.171875 67.09375 17.195312 72.777344 23.5625 C 78.457031 29.933594 76.238281 41.203125 67.808594 48.773438 Z M 67.808594 48.773438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 48 19 L 76 19 L 76 51 L 48 51 Z M 48 19 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 87.421875 47.683594 L 15.167969 83.617188 L -2.902344 47.28125 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-70"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 105.699219 84.4375 L 20.496094 126.808594 L -15.847656 53.71875 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-71"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 68.71875 13.421875 L 82.976562 42.09375 L 42.660156 62.144531 L 28.402344 33.472656 Z M 68.71875 13.421875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-72"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 67.808594 48.773438 C 61.859375 54.105469 52.136719 54.078125 45.859375 54.59375 C 44.5 54.761719 43.222656 55.179688 42.023438 55.847656 C 40.984375 55.238281 40.0625 54.484375 39.261719 53.582031 C 38.402344 52.621094 37.722656 51.542969 37.21875 50.355469 C 38.0625 49.238281 38.660156 48 39.011719 46.644531 C 40.273438 40.472656 41.339844 30.984375 47.195312 25.738281 C 55.636719 18.171875 67.09375 17.195312 72.777344 23.5625 C 78.457031 29.933594 76.238281 41.203125 67.808594 48.773438 Z M 67.808594 48.773438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 37 19 L 76 19 L 76 56 L 37 56 Z M 37 19 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 87.421875 47.683594 L 15.167969 83.617188 L -2.902344 47.28125 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-75"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 105.699219 84.4375 L 20.496094 126.808594 L -15.847656 53.71875 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-76"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 68.71875 13.421875 L 82.976562 42.09375 L 42.660156 62.144531 L 28.402344 33.472656 Z M 68.71875 13.421875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-77"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 67.808594 48.773438 C 61.859375 54.105469 52.136719 54.078125 45.859375 54.59375 C 44.5 54.761719 43.222656 55.179688 42.023438 55.847656 C 40.984375 55.238281 40.0625 54.484375 39.261719 53.582031 C 38.402344 52.621094 37.722656 51.542969 37.21875 50.355469 C 38.0625 49.238281 38.660156 48 39.011719 46.644531 C 40.273438 40.472656 41.339844 30.984375 47.195312 25.738281 C 55.636719 18.171875 67.09375 17.195312 72.777344 23.5625 C 78.457031 29.933594 76.238281 41.203125 67.808594 48.773438 Z M 67.808594 48.773438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-78"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 37 24 L 69 24 L 69 56 L 37 56 Z M 37 24 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-79"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 87.421875 47.683594 L 15.167969 83.617188 L -2.902344 47.28125 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-80"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 105.699219 84.4375 L 20.496094 126.808594 L -15.847656 53.71875 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-81"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 68.71875 13.421875 L 82.976562 42.09375 L 42.660156 62.144531 L 28.402344 33.472656 Z M 68.71875 13.421875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-82"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 67.808594 48.773438 C 61.859375 54.105469 52.136719 54.078125 45.859375 54.59375 C 44.5 54.761719 43.222656 55.179688 42.023438 55.847656 C 40.984375 55.238281 40.0625 54.484375 39.261719 53.582031 C 38.402344 52.621094 37.722656 51.542969 37.21875 50.355469 C 38.0625 49.238281 38.660156 48 39.011719 46.644531 C 40.273438 40.472656 41.339844 30.984375 47.195312 25.738281 C 55.636719 18.171875 67.09375 17.195312 72.777344 23.5625 C 78.457031 29.933594 76.238281 41.203125 67.808594 48.773438 Z M 67.808594 48.773438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 66 19 L 74 19 L 74 21 L 66 21 Z M 66 19 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-84"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 87.421875 47.683594 L 15.167969 83.617188 L -2.902344 47.28125 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-85"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 105.699219 84.4375 L 20.496094 126.808594 L -15.847656 53.71875 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-86"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 68.71875 13.421875 L 82.976562 42.09375 L 42.660156 62.144531 L 28.402344 33.472656 Z M 68.71875 13.421875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-87"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 67.808594 48.773438 C 61.859375 54.105469 52.136719 54.078125 45.859375 54.59375 C 44.5 54.761719 43.222656 55.179688 42.023438 55.847656 C 40.984375 55.238281 40.0625 54.484375 39.261719 53.582031 C 38.402344 52.621094 37.722656 51.542969 37.21875 50.355469 C 38.0625 49.238281 38.660156 48 39.011719 46.644531 C 40.273438 40.472656 41.339844 30.984375 47.195312 25.738281 C 55.636719 18.171875 67.09375 17.195312 72.777344 23.5625 C 78.457031 29.933594 76.238281 41.203125 67.808594 48.773438 Z M 67.808594 48.773438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 70 19 L 76 19 L 76 26 L 70 26 Z M 70 19 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-89"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 87.421875 47.683594 L 15.167969 83.617188 L -2.902344 47.28125 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-90"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 105.699219 84.4375 L 20.496094 126.808594 L -15.847656 53.71875 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-91"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 68.71875 13.421875 L 82.976562 42.09375 L 42.660156 62.144531 L 28.402344 33.472656 Z M 68.71875 13.421875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 67.808594 48.773438 C 61.859375 54.105469 52.136719 54.078125 45.859375 54.59375 C 44.5 54.761719 43.222656 55.179688 42.023438 55.847656 C 40.984375 55.238281 40.0625 54.484375 39.261719 53.582031 C 38.402344 52.621094 37.722656 51.542969 37.21875 50.355469 C 38.0625 49.238281 38.660156 48 39.011719 46.644531 C 40.273438 40.472656 41.339844 30.984375 47.195312 25.738281 C 55.636719 18.171875 67.09375 17.195312 72.777344 23.5625 C 78.457031 29.933594 76.238281 41.203125 67.808594 48.773438 Z M 67.808594 48.773438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-93"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 74 22 L 76 22 L 76 30 L 74 30 Z M 74 22 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 87.421875 47.683594 L 15.167969 83.617188 L -2.902344 47.28125 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-95"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 105.699219 84.4375 L 20.496094 126.808594 L -15.847656 53.71875 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-96"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 68.71875 13.421875 L 82.976562 42.09375 L 42.660156 62.144531 L 28.402344 33.472656 Z M 68.71875 13.421875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-97"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 67.808594 48.773438 C 61.859375 54.105469 52.136719 54.078125 45.859375 54.59375 C 44.5 54.761719 43.222656 55.179688 42.023438 55.847656 C 40.984375 55.238281 40.0625 54.484375 39.261719 53.582031 C 38.402344 52.621094 37.722656 51.542969 37.21875 50.355469 C 38.0625 49.238281 38.660156 48 39.011719 46.644531 C 40.273438 40.472656 41.339844 30.984375 47.195312 25.738281 C 55.636719 18.171875 67.09375 17.195312 72.777344 23.5625 C 78.457031 29.933594 76.238281 41.203125 67.808594 48.773438 Z M 67.808594 48.773438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-98"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 50 19 L 58 19 L 58 27 L 50 27 Z M 50 19 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-99"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 87.421875 47.683594 L 15.167969 83.617188 L -2.902344 47.28125 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 105.699219 84.4375 L 20.496094 126.808594 L -15.847656 53.71875 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-101"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 68.71875 13.421875 L 82.976562 42.09375 L 42.660156 62.144531 L 28.402344 33.472656 Z M 68.71875 13.421875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-102"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 67.808594 48.773438 C 61.859375 54.105469 52.136719 54.078125 45.859375 54.59375 C 44.5 54.761719 43.222656 55.179688 42.023438 55.847656 C 40.984375 55.238281 40.0625 54.484375 39.261719 53.582031 C 38.402344 52.621094 37.722656 51.542969 37.21875 50.355469 C 38.0625 49.238281 38.660156 48 39.011719 46.644531 C 40.273438 40.472656 41.339844 30.984375 47.195312 25.738281 C 55.636719 18.171875 67.09375 17.195312 72.777344 23.5625 C 78.457031 29.933594 76.238281 41.203125 67.808594 48.773438 Z M 67.808594 48.773438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-103"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 54 24 L 62 24 L 62 32 L 54 32 Z M 54 24 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-104"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 87.421875 47.683594 L 15.167969 83.617188 L -2.902344 47.28125 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-105"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 105.699219 84.4375 L 20.496094 126.808594 L -15.847656 53.71875 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-106"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 68.71875 13.421875 L 82.976562 42.09375 L 42.660156 62.144531 L 28.402344 33.472656 Z M 68.71875 13.421875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-107"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 67.808594 48.773438 C 61.859375 54.105469 52.136719 54.078125 45.859375 54.59375 C 44.5 54.761719 43.222656 55.179688 42.023438 55.847656 C 40.984375 55.238281 40.0625 54.484375 39.261719 53.582031 C 38.402344 52.621094 37.722656 51.542969 37.21875 50.355469 C 38.0625 49.238281 38.660156 48 39.011719 46.644531 C 40.273438 40.472656 41.339844 30.984375 47.195312 25.738281 C 55.636719 18.171875 67.09375 17.195312 72.777344 23.5625 C 78.457031 29.933594 76.238281 41.203125 67.808594 48.773438 Z M 67.808594 48.773438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-108"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 58 28 L 66 28 L 66 36 L 58 36 Z M 58 28 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-109"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 87.421875 47.683594 L 15.167969 83.617188 L -2.902344 47.28125 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-110"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 105.699219 84.4375 L 20.496094 126.808594 L -15.847656 53.71875 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-111"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 68.71875 13.421875 L 82.976562 42.09375 L 42.660156 62.144531 L 28.402344 33.472656 Z M 68.71875 13.421875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-112"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 67.808594 48.773438 C 61.859375 54.105469 52.136719 54.078125 45.859375 54.59375 C 44.5 54.761719 43.222656 55.179688 42.023438 55.847656 C 40.984375 55.238281 40.0625 54.484375 39.261719 53.582031 C 38.402344 52.621094 37.722656 51.542969 37.21875 50.355469 C 38.0625 49.238281 38.660156 48 39.011719 46.644531 C 40.273438 40.472656 41.339844 30.984375 47.195312 25.738281 C 55.636719 18.171875 67.09375 17.195312 72.777344 23.5625 C 78.457031 29.933594 76.238281 41.203125 67.808594 48.773438 Z M 67.808594 48.773438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-113"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 62 33 L 70 33 L 70 41 L 62 41 Z M 62 33 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-114"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 87.421875 47.683594 L 15.167969 83.617188 L -2.902344 47.28125 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-115"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 105.699219 84.4375 L 20.496094 126.808594 L -15.847656 53.71875 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-116"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 68.71875 13.421875 L 82.976562 42.09375 L 42.660156 62.144531 L 28.402344 33.472656 Z M 68.71875 13.421875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-117"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 67.808594 48.773438 C 61.859375 54.105469 52.136719 54.078125 45.859375 54.59375 C 44.5 54.761719 43.222656 55.179688 42.023438 55.847656 C 40.984375 55.238281 40.0625 54.484375 39.261719 53.582031 C 38.402344 52.621094 37.722656 51.542969 37.21875 50.355469 C 38.0625 49.238281 38.660156 48 39.011719 46.644531 C 40.273438 40.472656 41.339844 30.984375 47.195312 25.738281 C 55.636719 18.171875 67.09375 17.195312 72.777344 23.5625 C 78.457031 29.933594 76.238281 41.203125 67.808594 48.773438 Z M 67.808594 48.773438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-118"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 66 37 L 75 37 L 75 45 L 66 45 Z M 66 37 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-119"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 87.421875 47.683594 L 15.167969 83.617188 L -2.902344 47.28125 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-120"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 105.699219 84.4375 L 20.496094 126.808594 L -15.847656 53.71875 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-121"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 68.71875 13.421875 L 82.976562 42.09375 L 42.660156 62.144531 L 28.402344 33.472656 Z M 68.71875 13.421875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-122"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 67.808594 48.773438 C 61.859375 54.105469 52.136719 54.078125 45.859375 54.59375 C 44.5 54.761719 43.222656 55.179688 42.023438 55.847656 C 40.984375 55.238281 40.0625 54.484375 39.261719 53.582031 C 38.402344 52.621094 37.722656 51.542969 37.21875 50.355469 C 38.0625 49.238281 38.660156 48 39.011719 46.644531 C 40.273438 40.472656 41.339844 30.984375 47.195312 25.738281 C 55.636719 18.171875 67.09375 17.195312 72.777344 23.5625 C 78.457031 29.933594 76.238281 41.203125 67.808594 48.773438 Z M 67.808594 48.773438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-123"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 70 42 L 76 42 L 76 50 L 70 50 Z M 70 42 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-124"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 87.421875 47.683594 L 15.167969 83.617188 L -2.902344 47.28125 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-125"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 105.699219 84.4375 L 20.496094 126.808594 L -15.847656 53.71875 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-126"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 68.71875 13.421875 L 82.976562 42.09375 L 42.660156 62.144531 L 28.402344 33.472656 Z M 68.71875 13.421875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-127"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 67.808594 48.773438 C 61.859375 54.105469 52.136719 54.078125 45.859375 54.59375 C 44.5 54.761719 43.222656 55.179688 42.023438 55.847656 C 40.984375 55.238281 40.0625 54.484375 39.261719 53.582031 C 38.402344 52.621094 37.722656 51.542969 37.21875 50.355469 C 38.0625 49.238281 38.660156 48 39.011719 46.644531 C 40.273438 40.472656 41.339844 30.984375 47.195312 25.738281 C 55.636719 18.171875 67.09375 17.195312 72.777344 23.5625 C 78.457031 29.933594 76.238281 41.203125 67.808594 48.773438 Z M 67.808594 48.773438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-128"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 38 30 L 46 30 L 46 38 L 38 38 Z M 38 30 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-129"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 87.421875 47.683594 L 15.167969 83.617188 L -2.902344 47.28125 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-130"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 105.699219 84.4375 L 20.496094 126.808594 L -15.847656 53.71875 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-131"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 68.71875 13.421875 L 82.976562 42.09375 L 42.660156 62.144531 L 28.402344 33.472656 Z M 68.71875 13.421875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-132"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 67.808594 48.773438 C 61.859375 54.105469 52.136719 54.078125 45.859375 54.59375 C 44.5 54.761719 43.222656 55.179688 42.023438 55.847656 C 40.984375 55.238281 40.0625 54.484375 39.261719 53.582031 C 38.402344 52.621094 37.722656 51.542969 37.21875 50.355469 C 38.0625 49.238281 38.660156 48 39.011719 46.644531 C 40.273438 40.472656 41.339844 30.984375 47.195312 25.738281 C 55.636719 18.171875 67.09375 17.195312 72.777344 23.5625 C 78.457031 29.933594 76.238281 41.203125 67.808594 48.773438 Z M 67.808594 48.773438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-133"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 42 35 L 50 35 L 50 43 L 42 43 Z M 42 35 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-134"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 87.421875 47.683594 L 15.167969 83.617188 L -2.902344 47.28125 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-135"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 105.699219 84.4375 L 20.496094 126.808594 L -15.847656 53.71875 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-136"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 68.71875 13.421875 L 82.976562 42.09375 L 42.660156 62.144531 L 28.402344 33.472656 Z M 68.71875 13.421875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-137"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 67.808594 48.773438 C 61.859375 54.105469 52.136719 54.078125 45.859375 54.59375 C 44.5 54.761719 43.222656 55.179688 42.023438 55.847656 C 40.984375 55.238281 40.0625 54.484375 39.261719 53.582031 C 38.402344 52.621094 37.722656 51.542969 37.21875 50.355469 C 38.0625 49.238281 38.660156 48 39.011719 46.644531 C 40.273438 40.472656 41.339844 30.984375 47.195312 25.738281 C 55.636719 18.171875 67.09375 17.195312 72.777344 23.5625 C 78.457031 29.933594 76.238281 41.203125 67.808594 48.773438 Z M 67.808594 48.773438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-138"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 46 39 L 54 39 L 54 47 L 46 47 Z M 46 39 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-139"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 87.421875 47.683594 L 15.167969 83.617188 L -2.902344 47.28125 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-140"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 105.699219 84.4375 L 20.496094 126.808594 L -15.847656 53.71875 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-141"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 68.71875 13.421875 L 82.976562 42.09375 L 42.660156 62.144531 L 28.402344 33.472656 Z M 68.71875 13.421875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-142"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 67.808594 48.773438 C 61.859375 54.105469 52.136719 54.078125 45.859375 54.59375 C 44.5 54.761719 43.222656 55.179688 42.023438 55.847656 C 40.984375 55.238281 40.0625 54.484375 39.261719 53.582031 C 38.402344 52.621094 37.722656 51.542969 37.21875 50.355469 C 38.0625 49.238281 38.660156 48 39.011719 46.644531 C 40.273438 40.472656 41.339844 30.984375 47.195312 25.738281 C 55.636719 18.171875 67.09375 17.195312 72.777344 23.5625 C 78.457031 29.933594 76.238281 41.203125 67.808594 48.773438 Z M 67.808594 48.773438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-143"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 50 44 L 58 44 L 58 52 L 50 52 Z M 50 44 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-144"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 87.421875 47.683594 L 15.167969 83.617188 L -2.902344 47.28125 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-145"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 105.699219 84.4375 L 20.496094 126.808594 L -15.847656 53.71875 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-146"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 68.71875 13.421875 L 82.976562 42.09375 L 42.660156 62.144531 L 28.402344 33.472656 Z M 68.71875 13.421875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-147"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 67.808594 48.773438 C 61.859375 54.105469 52.136719 54.078125 45.859375 54.59375 C 44.5 54.761719 43.222656 55.179688 42.023438 55.847656 C 40.984375 55.238281 40.0625 54.484375 39.261719 53.582031 C 38.402344 52.621094 37.722656 51.542969 37.21875 50.355469 C 38.0625 49.238281 38.660156 48 39.011719 46.644531 C 40.273438 40.472656 41.339844 30.984375 47.195312 25.738281 C 55.636719 18.171875 67.09375 17.195312 72.777344 23.5625 C 78.457031 29.933594 76.238281 41.203125 67.808594 48.773438 Z M 67.808594 48.773438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-148"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 54 48 L 62 48 L 62 56 L 54 56 Z M 54 48 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-149"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 87.421875 47.683594 L 15.167969 83.617188 L -2.902344 47.28125 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-150"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 105.699219 84.4375 L 20.496094 126.808594 L -15.847656 53.71875 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-151"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 68.71875 13.421875 L 82.976562 42.09375 L 42.660156 62.144531 L 28.402344 33.472656 Z M 68.71875 13.421875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-152"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 67.808594 48.773438 C 61.859375 54.105469 52.136719 54.078125 45.859375 54.59375 C 44.5 54.761719 43.222656 55.179688 42.023438 55.847656 C 40.984375 55.238281 40.0625 54.484375 39.261719 53.582031 C 38.402344 52.621094 37.722656 51.542969 37.21875 50.355469 C 38.0625 49.238281 38.660156 48 39.011719 46.644531 C 40.273438 40.472656 41.339844 30.984375 47.195312 25.738281 C 55.636719 18.171875 67.09375 17.195312 72.777344 23.5625 C 78.457031 29.933594 76.238281 41.203125 67.808594 48.773438 Z M 67.808594 48.773438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-153"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 58 53 L 67 53 L 67 56 L 58 56 Z M 58 53 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-154"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 87.421875 47.683594 L 15.167969 83.617188 L -2.902344 47.28125 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-155"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 105.699219 84.4375 L 20.496094 126.808594 L -15.847656 53.71875 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-156"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 68.71875 13.421875 L 82.976562 42.09375 L 42.660156 62.144531 L 28.402344 33.472656 Z M 68.71875 13.421875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-157"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 67.808594 48.773438 C 61.859375 54.105469 52.136719 54.078125 45.859375 54.59375 C 44.5 54.761719 43.222656 55.179688 42.023438 55.847656 C 40.984375 55.238281 40.0625 54.484375 39.261719 53.582031 C 38.402344 52.621094 37.722656 51.542969 37.21875 50.355469 C 38.0625 49.238281 38.660156 48 39.011719 46.644531 C 40.273438 40.472656 41.339844 30.984375 47.195312 25.738281 C 55.636719 18.171875 67.09375 17.195312 72.777344 23.5625 C 78.457031 29.933594 76.238281 41.203125 67.808594 48.773438 Z M 67.808594 48.773438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-158"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7 49 L 44 49 L 44 77 L 7 77 Z M 7 49 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 87.421875 47.683594 L 15.167969 83.617188 L -2.902344 47.28125 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-160"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.351562 11.347656 L 105.699219 84.4375 L 20.496094 126.808594 L -15.847656 53.71875 Z M 69.351562 11.347656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-1"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-remove-color)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -8.25,
    width: 99,
    fill: "rgb(0%, 0%, 0%)",
    y: -8.25,
    height: 98.999997,
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-161"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5 1 L 32 1 L 32 27.8125 L 5 27.8125 Z M 5 1 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-162"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 62.351562 -37.652344 L 80.421875 -1.316406 L 8.167969 34.617188 L -9.902344 -1.71875 Z M 62.351562 -37.652344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-163"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 62.351562 -37.652344 L 98.699219 35.4375 L 13.496094 77.808594 L -22.847656 4.71875 Z M 62.351562 -37.652344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-164"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 37,
    y: 0,
    height: 28
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-165"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26 29 L 53 29 L 53 82.003906 L 26 82.003906 Z M 26 29 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-166"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 52.332031 5.554688 L 32.171875 83.691406 L -7.121094 73.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-167"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 92.078125 15.8125 L 68.304688 107.949219 L -10.734375 87.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 46 30 L 53 30 L 53 70 L 46 70 Z M 46 30 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-169"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 52.332031 5.554688 L 32.171875 83.691406 L -7.121094 73.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-170"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 92.078125 15.8125 L 68.304688 107.949219 L -10.734375 87.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-171"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 53.996094 25.453125 L 85.527344 33.589844 L 74.683594 75.613281 L 43.152344 67.480469 Z M 53.996094 25.453125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-172"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 76.660156 57.972656 C 71.851562 64.34375 62.304688 66.203125 56.238281 67.917969 C 54.9375 68.347656 53.761719 69.007812 52.714844 69.890625 C 50.296875 69.042969 48.375 67.558594 46.945312 65.433594 C 47.550781 64.179688 47.890625 62.855469 47.96875 61.464844 C 48.011719 55.164062 47.234375 45.648438 51.988281 39.367188 C 58.804688 30.320312 69.859375 27.171875 76.683594 32.292969 C 83.503906 37.414062 83.480469 48.929688 76.660156 57.972656 Z M 76.660156 57.972656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-173"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 46 29 L 53 29 L 53 70 L 46 70 Z M 46 29 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-174"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 52.332031 5.554688 L 32.171875 83.691406 L -7.121094 73.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-175"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 92.078125 15.8125 L 68.304688 107.949219 L -10.734375 87.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-176"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 53.996094 25.453125 L 85.527344 33.589844 L 74.683594 75.613281 L 43.152344 67.480469 Z M 53.996094 25.453125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-177"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 76.660156 57.972656 C 71.851562 64.34375 62.304688 66.203125 56.238281 67.917969 C 54.9375 68.347656 53.761719 69.007812 52.714844 69.890625 C 50.296875 69.042969 48.375 67.558594 46.945312 65.433594 C 47.550781 64.179688 47.890625 62.855469 47.96875 61.464844 C 48.011719 55.164062 47.234375 45.648438 51.988281 39.367188 C 58.804688 30.320312 69.859375 27.171875 76.683594 32.292969 C 83.503906 37.414062 83.480469 48.929688 76.660156 57.972656 Z M 76.660156 57.972656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-178"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 49 29 L 53 29 L 53 57 L 49 57 Z M 49 29 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-179"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 52.332031 5.554688 L 32.171875 83.691406 L -7.121094 73.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-180"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 92.078125 15.8125 L 68.304688 107.949219 L -10.734375 87.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-181"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 53.996094 25.453125 L 85.527344 33.589844 L 74.683594 75.613281 L 43.152344 67.480469 Z M 53.996094 25.453125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-182"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 76.660156 57.972656 C 71.851562 64.34375 62.304688 66.203125 56.238281 67.917969 C 54.9375 68.347656 53.761719 69.007812 52.714844 69.890625 C 50.296875 69.042969 48.375 67.558594 46.945312 65.433594 C 47.550781 64.179688 47.890625 62.855469 47.96875 61.464844 C 48.011719 55.164062 47.234375 45.648438 51.988281 39.367188 C 58.804688 30.320312 69.859375 27.171875 76.683594 32.292969 C 83.503906 37.414062 83.480469 48.929688 76.660156 57.972656 Z M 76.660156 57.972656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-183"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 46 29 L 53 29 L 53 70 L 46 70 Z M 46 29 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-184"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 52.332031 5.554688 L 32.171875 83.691406 L -7.121094 73.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-185"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 92.078125 15.8125 L 68.304688 107.949219 L -10.734375 87.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-186"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 53.996094 25.453125 L 85.527344 33.589844 L 74.683594 75.613281 L 43.152344 67.480469 Z M 53.996094 25.453125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-187"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 76.660156 57.972656 C 71.851562 64.34375 62.304688 66.203125 56.238281 67.917969 C 54.9375 68.347656 53.761719 69.007812 52.714844 69.890625 C 50.296875 69.042969 48.375 67.558594 46.945312 65.433594 C 47.550781 64.179688 47.890625 62.855469 47.96875 61.464844 C 48.011719 55.164062 47.234375 45.648438 51.988281 39.367188 C 58.804688 30.320312 69.859375 27.171875 76.683594 32.292969 C 83.503906 37.414062 83.480469 48.929688 76.660156 57.972656 Z M 76.660156 57.972656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-188"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 46 41 L 53 41 L 53 70 L 46 70 Z M 46 41 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-189"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 52.332031 5.554688 L 32.171875 83.691406 L -7.121094 73.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-190"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 92.078125 15.8125 L 68.304688 107.949219 L -10.734375 87.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-191"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 53.996094 25.453125 L 85.527344 33.589844 L 74.683594 75.613281 L 43.152344 67.480469 Z M 53.996094 25.453125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-192"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 76.660156 57.972656 C 71.851562 64.34375 62.304688 66.203125 56.238281 67.917969 C 54.9375 68.347656 53.761719 69.007812 52.714844 69.890625 C 50.296875 69.042969 48.375 67.558594 46.945312 65.433594 C 47.550781 64.179688 47.890625 62.855469 47.96875 61.464844 C 48.011719 55.164062 47.234375 45.648438 51.988281 39.367188 C 58.804688 30.320312 69.859375 27.171875 76.683594 32.292969 C 83.503906 37.414062 83.480469 48.929688 76.660156 57.972656 Z M 76.660156 57.972656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-193"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 46 44 L 52 44 L 52 52 L 46 52 Z M 46 44 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-194"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 52.332031 5.554688 L 32.171875 83.691406 L -7.121094 73.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-195"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 92.078125 15.8125 L 68.304688 107.949219 L -10.734375 87.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-196"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 53.996094 25.453125 L 85.527344 33.589844 L 74.683594 75.613281 L 43.152344 67.480469 Z M 53.996094 25.453125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-197"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 76.660156 57.972656 C 71.851562 64.34375 62.304688 66.203125 56.238281 67.917969 C 54.9375 68.347656 53.761719 69.007812 52.714844 69.890625 C 50.296875 69.042969 48.375 67.558594 46.945312 65.433594 C 47.550781 64.179688 47.890625 62.855469 47.96875 61.464844 C 48.011719 55.164062 47.234375 45.648438 51.988281 39.367188 C 58.804688 30.320312 69.859375 27.171875 76.683594 32.292969 C 83.503906 37.414062 83.480469 48.929688 76.660156 57.972656 Z M 76.660156 57.972656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-198"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 49 47 L 53 47 L 53 56 L 49 56 Z M 49 47 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-199"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 52.332031 5.554688 L 32.171875 83.691406 L -7.121094 73.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-200"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 92.078125 15.8125 L 68.304688 107.949219 L -10.734375 87.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-201"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 53.996094 25.453125 L 85.527344 33.589844 L 74.683594 75.613281 L 43.152344 67.480469 Z M 53.996094 25.453125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-202"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 76.660156 57.972656 C 71.851562 64.34375 62.304688 66.203125 56.238281 67.917969 C 54.9375 68.347656 53.761719 69.007812 52.714844 69.890625 C 50.296875 69.042969 48.375 67.558594 46.945312 65.433594 C 47.550781 64.179688 47.890625 62.855469 47.96875 61.464844 C 48.011719 55.164062 47.234375 45.648438 51.988281 39.367188 C 58.804688 30.320312 69.859375 27.171875 76.683594 32.292969 C 83.503906 37.414062 83.480469 48.929688 76.660156 57.972656 Z M 76.660156 57.972656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-203"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26 61 L 50 61 L 50 82.003906 L 26 82.003906 Z M 26 61 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-204"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 52.332031 5.554688 L 32.171875 83.691406 L -7.121094 73.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-205"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 92.078125 15.8125 L 68.304688 107.949219 L -10.734375 87.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-remove-color)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -8.25,
    width: 99,
    fill: "rgb(0%, 0%, 0%)",
    y: -8.25,
    height: 98.999997,
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-206"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.00390625 4 L 23.859375 4 L 23.859375 21.003906 L 0.00390625 21.003906 Z M 0.00390625 4 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-207"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -12.960938 -65.582031 L 26.332031 -55.445312 L 6.171875 22.691406 L -33.121094 12.554688 Z M -12.960938 -65.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-208"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -12.960938 -65.582031 L 66.078125 -45.1875 L 42.304688 46.949219 L -36.734375 26.554688 Z M -12.960938 -65.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-209"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 24,
    y: 0,
    height: 22
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-210"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9 0 L 40 0 L 40 82 L 9 82 Z M 9 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-211"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 52.332031 5.554688 L 32.171875 83.691406 L -7.121094 73.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-212"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 92.078125 15.8125 L 68.304688 107.949219 L -10.734375 87.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-213"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9 1 L 41 1 L 41 46 L 9 46 Z M 9 1 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-214"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 52.332031 5.554688 L 32.171875 83.691406 L -7.121094 73.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-215"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 92.078125 15.8125 L 68.304688 107.949219 L -10.734375 87.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-216"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.191406 -2.746094 L 45.195312 5.253906 L 33.945312 48.855469 L 2.941406 40.855469 Z M 14.191406 -2.746094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-217"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 40.308594 21.09375 C 40.445312 29.078125 34.058594 36.410156 30.335938 41.492188 C 29.574219 42.628906 29.050781 43.871094 28.769531 45.210938 C 27.628906 45.597656 26.457031 45.800781 25.253906 45.816406 C 23.960938 45.835938 22.703125 45.644531 21.476562 45.246094 C 21.183594 43.875 20.640625 42.617188 19.84375 41.464844 C 16.007812 36.464844 9.53125 29.445312 9.402344 21.585938 C 9.210938 10.25 15.976562 0.953125 24.511719 0.828125 C 33.046875 0.707031 40.109375 9.761719 40.308594 21.09375 Z M 40.308594 21.09375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-218"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9 0 L 41 0 L 41 10 L 9 10 Z M 9 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-219"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 52.332031 5.554688 L 32.171875 83.691406 L -7.121094 73.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-220"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 92.078125 15.8125 L 68.304688 107.949219 L -10.734375 87.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-221"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.191406 -2.746094 L 45.195312 5.253906 L 33.945312 48.855469 L 2.941406 40.855469 Z M 14.191406 -2.746094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-222"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 40.308594 21.09375 C 40.445312 29.078125 34.058594 36.410156 30.335938 41.492188 C 29.574219 42.628906 29.050781 43.871094 28.769531 45.210938 C 27.628906 45.597656 26.457031 45.800781 25.253906 45.816406 C 23.960938 45.835938 22.703125 45.644531 21.476562 45.246094 C 21.183594 43.875 20.640625 42.617188 19.84375 41.464844 C 16.007812 36.464844 9.53125 29.445312 9.402344 21.585938 C 9.210938 10.25 15.976562 0.953125 24.511719 0.828125 C 33.046875 0.707031 40.109375 9.761719 40.308594 21.09375 Z M 40.308594 21.09375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-223"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9 16 L 41 16 L 41 26 L 9 26 Z M 9 16 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-224"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 52.332031 5.554688 L 32.171875 83.691406 L -7.121094 73.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-225"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 92.078125 15.8125 L 68.304688 107.949219 L -10.734375 87.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-226"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.191406 -2.746094 L 45.195312 5.253906 L 33.945312 48.855469 L 2.941406 40.855469 Z M 14.191406 -2.746094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-227"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 40.308594 21.09375 C 40.445312 29.078125 34.058594 36.410156 30.335938 41.492188 C 29.574219 42.628906 29.050781 43.871094 28.769531 45.210938 C 27.628906 45.597656 26.457031 45.800781 25.253906 45.816406 C 23.960938 45.835938 22.703125 45.644531 21.476562 45.246094 C 21.183594 43.875 20.640625 42.617188 19.84375 41.464844 C 16.007812 36.464844 9.53125 29.445312 9.402344 21.585938 C 9.210938 10.25 15.976562 0.953125 24.511719 0.828125 C 33.046875 0.707031 40.109375 9.761719 40.308594 21.09375 Z M 40.308594 21.09375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-228"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9 33 L 41 33 L 41 43 L 9 43 Z M 9 33 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-229"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 52.332031 5.554688 L 32.171875 83.691406 L -7.121094 73.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-230"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 92.078125 15.8125 L 68.304688 107.949219 L -10.734375 87.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-231"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.191406 -2.746094 L 45.195312 5.253906 L 33.945312 48.855469 L 2.941406 40.855469 Z M 14.191406 -2.746094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-232"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 40.308594 21.09375 C 40.445312 29.078125 34.058594 36.410156 30.335938 41.492188 C 29.574219 42.628906 29.050781 43.871094 28.769531 45.210938 C 27.628906 45.597656 26.457031 45.800781 25.253906 45.816406 C 23.960938 45.835938 22.703125 45.644531 21.476562 45.246094 C 21.183594 43.875 20.640625 42.617188 19.84375 41.464844 C 16.007812 36.464844 9.53125 29.445312 9.402344 21.585938 C 9.210938 10.25 15.976562 0.953125 24.511719 0.828125 C 33.046875 0.707031 40.109375 9.761719 40.308594 21.09375 Z M 40.308594 21.09375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-233"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9 9 L 16 9 L 16 17 L 9 17 Z M 9 9 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-234"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 52.332031 5.554688 L 32.171875 83.691406 L -7.121094 73.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-235"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 92.078125 15.8125 L 68.304688 107.949219 L -10.734375 87.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-236"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.191406 -2.746094 L 45.195312 5.253906 L 33.945312 48.855469 L 2.941406 40.855469 Z M 14.191406 -2.746094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-237"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 40.308594 21.09375 C 40.445312 29.078125 34.058594 36.410156 30.335938 41.492188 C 29.574219 42.628906 29.050781 43.871094 28.769531 45.210938 C 27.628906 45.597656 26.457031 45.800781 25.253906 45.816406 C 23.960938 45.835938 22.703125 45.644531 21.476562 45.246094 C 21.183594 43.875 20.640625 42.617188 19.84375 41.464844 C 16.007812 36.464844 9.53125 29.445312 9.402344 21.585938 C 9.210938 10.25 15.976562 0.953125 24.511719 0.828125 C 33.046875 0.707031 40.109375 9.761719 40.308594 21.09375 Z M 40.308594 21.09375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-238"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14 9 L 22 9 L 22 17 L 14 17 Z M 14 9 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-239"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 52.332031 5.554688 L 32.171875 83.691406 L -7.121094 73.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-240"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 92.078125 15.8125 L 68.304688 107.949219 L -10.734375 87.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-241"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.191406 -2.746094 L 45.195312 5.253906 L 33.945312 48.855469 L 2.941406 40.855469 Z M 14.191406 -2.746094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-242"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 40.308594 21.09375 C 40.445312 29.078125 34.058594 36.410156 30.335938 41.492188 C 29.574219 42.628906 29.050781 43.871094 28.769531 45.210938 C 27.628906 45.597656 26.457031 45.800781 25.253906 45.816406 C 23.960938 45.835938 22.703125 45.644531 21.476562 45.246094 C 21.183594 43.875 20.640625 42.617188 19.84375 41.464844 C 16.007812 36.464844 9.53125 29.445312 9.402344 21.585938 C 9.210938 10.25 15.976562 0.953125 24.511719 0.828125 C 33.046875 0.707031 40.109375 9.761719 40.308594 21.09375 Z M 40.308594 21.09375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-243"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 20 9 L 28 9 L 28 16 L 20 16 Z M 20 9 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-244"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 52.332031 5.554688 L 32.171875 83.691406 L -7.121094 73.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-245"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 92.078125 15.8125 L 68.304688 107.949219 L -10.734375 87.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-246"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.191406 -2.746094 L 45.195312 5.253906 L 33.945312 48.855469 L 2.941406 40.855469 Z M 14.191406 -2.746094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-247"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 40.308594 21.09375 C 40.445312 29.078125 34.058594 36.410156 30.335938 41.492188 C 29.574219 42.628906 29.050781 43.871094 28.769531 45.210938 C 27.628906 45.597656 26.457031 45.800781 25.253906 45.816406 C 23.960938 45.835938 22.703125 45.644531 21.476562 45.246094 C 21.183594 43.875 20.640625 42.617188 19.84375 41.464844 C 16.007812 36.464844 9.53125 29.445312 9.402344 21.585938 C 9.210938 10.25 15.976562 0.953125 24.511719 0.828125 C 33.046875 0.707031 40.109375 9.761719 40.308594 21.09375 Z M 40.308594 21.09375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-248"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26 9 L 34 9 L 34 16 L 26 16 Z M 26 9 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-249"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 52.332031 5.554688 L 32.171875 83.691406 L -7.121094 73.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-250"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 92.078125 15.8125 L 68.304688 107.949219 L -10.734375 87.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-251"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.191406 -2.746094 L 45.195312 5.253906 L 33.945312 48.855469 L 2.941406 40.855469 Z M 14.191406 -2.746094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-252"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 40.308594 21.09375 C 40.445312 29.078125 34.058594 36.410156 30.335938 41.492188 C 29.574219 42.628906 29.050781 43.871094 28.769531 45.210938 C 27.628906 45.597656 26.457031 45.800781 25.253906 45.816406 C 23.960938 45.835938 22.703125 45.644531 21.476562 45.246094 C 21.183594 43.875 20.640625 42.617188 19.84375 41.464844 C 16.007812 36.464844 9.53125 29.445312 9.402344 21.585938 C 9.210938 10.25 15.976562 0.953125 24.511719 0.828125 C 33.046875 0.707031 40.109375 9.761719 40.308594 21.09375 Z M 40.308594 21.09375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-253"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 32 9 L 40 9 L 40 16 L 32 16 Z M 32 9 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-254"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 52.332031 5.554688 L 32.171875 83.691406 L -7.121094 73.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-255"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 92.078125 15.8125 L 68.304688 107.949219 L -10.734375 87.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-256"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.191406 -2.746094 L 45.195312 5.253906 L 33.945312 48.855469 L 2.941406 40.855469 Z M 14.191406 -2.746094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-257"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 40.308594 21.09375 C 40.445312 29.078125 34.058594 36.410156 30.335938 41.492188 C 29.574219 42.628906 29.050781 43.871094 28.769531 45.210938 C 27.628906 45.597656 26.457031 45.800781 25.253906 45.816406 C 23.960938 45.835938 22.703125 45.644531 21.476562 45.246094 C 21.183594 43.875 20.640625 42.617188 19.84375 41.464844 C 16.007812 36.464844 9.53125 29.445312 9.402344 21.585938 C 9.210938 10.25 15.976562 0.953125 24.511719 0.828125 C 33.046875 0.707031 40.109375 9.761719 40.308594 21.09375 Z M 40.308594 21.09375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-258"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 38 9 L 41 9 L 41 16 L 38 16 Z M 38 9 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-259"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 52.332031 5.554688 L 32.171875 83.691406 L -7.121094 73.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-260"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 92.078125 15.8125 L 68.304688 107.949219 L -10.734375 87.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-261"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.191406 -2.746094 L 45.195312 5.253906 L 33.945312 48.855469 L 2.941406 40.855469 Z M 14.191406 -2.746094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-262"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 40.308594 21.09375 C 40.445312 29.078125 34.058594 36.410156 30.335938 41.492188 C 29.574219 42.628906 29.050781 43.871094 28.769531 45.210938 C 27.628906 45.597656 26.457031 45.800781 25.253906 45.816406 C 23.960938 45.835938 22.703125 45.644531 21.476562 45.246094 C 21.183594 43.875 20.640625 42.617188 19.84375 41.464844 C 16.007812 36.464844 9.53125 29.445312 9.402344 21.585938 C 9.210938 10.25 15.976562 0.953125 24.511719 0.828125 C 33.046875 0.707031 40.109375 9.761719 40.308594 21.09375 Z M 40.308594 21.09375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-263"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9 25 L 16 25 L 16 33 L 9 33 Z M 9 25 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-264"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 52.332031 5.554688 L 32.171875 83.691406 L -7.121094 73.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-265"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 92.078125 15.8125 L 68.304688 107.949219 L -10.734375 87.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-266"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.191406 -2.746094 L 45.195312 5.253906 L 33.945312 48.855469 L 2.941406 40.855469 Z M 14.191406 -2.746094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-267"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 40.308594 21.09375 C 40.445312 29.078125 34.058594 36.410156 30.335938 41.492188 C 29.574219 42.628906 29.050781 43.871094 28.769531 45.210938 C 27.628906 45.597656 26.457031 45.800781 25.253906 45.816406 C 23.960938 45.835938 22.703125 45.644531 21.476562 45.246094 C 21.183594 43.875 20.640625 42.617188 19.84375 41.464844 C 16.007812 36.464844 9.53125 29.445312 9.402344 21.585938 C 9.210938 10.25 15.976562 0.953125 24.511719 0.828125 C 33.046875 0.707031 40.109375 9.761719 40.308594 21.09375 Z M 40.308594 21.09375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-268"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14 25 L 22 25 L 22 33 L 14 33 Z M 14 25 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-269"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 52.332031 5.554688 L 32.171875 83.691406 L -7.121094 73.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-270"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 92.078125 15.8125 L 68.304688 107.949219 L -10.734375 87.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-271"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.191406 -2.746094 L 45.195312 5.253906 L 33.945312 48.855469 L 2.941406 40.855469 Z M 14.191406 -2.746094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-272"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 40.308594 21.09375 C 40.445312 29.078125 34.058594 36.410156 30.335938 41.492188 C 29.574219 42.628906 29.050781 43.871094 28.769531 45.210938 C 27.628906 45.597656 26.457031 45.800781 25.253906 45.816406 C 23.960938 45.835938 22.703125 45.644531 21.476562 45.246094 C 21.183594 43.875 20.640625 42.617188 19.84375 41.464844 C 16.007812 36.464844 9.53125 29.445312 9.402344 21.585938 C 9.210938 10.25 15.976562 0.953125 24.511719 0.828125 C 33.046875 0.707031 40.109375 9.761719 40.308594 21.09375 Z M 40.308594 21.09375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-273"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 20 25 L 29 25 L 29 33 L 20 33 Z M 20 25 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-274"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 52.332031 5.554688 L 32.171875 83.691406 L -7.121094 73.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-275"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 92.078125 15.8125 L 68.304688 107.949219 L -10.734375 87.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-276"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.191406 -2.746094 L 45.195312 5.253906 L 33.945312 48.855469 L 2.941406 40.855469 Z M 14.191406 -2.746094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-277"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 40.308594 21.09375 C 40.445312 29.078125 34.058594 36.410156 30.335938 41.492188 C 29.574219 42.628906 29.050781 43.871094 28.769531 45.210938 C 27.628906 45.597656 26.457031 45.800781 25.253906 45.816406 C 23.960938 45.835938 22.703125 45.644531 21.476562 45.246094 C 21.183594 43.875 20.640625 42.617188 19.84375 41.464844 C 16.007812 36.464844 9.53125 29.445312 9.402344 21.585938 C 9.210938 10.25 15.976562 0.953125 24.511719 0.828125 C 33.046875 0.707031 40.109375 9.761719 40.308594 21.09375 Z M 40.308594 21.09375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-278"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26 25 L 35 25 L 35 33 L 26 33 Z M 26 25 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-279"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 52.332031 5.554688 L 32.171875 83.691406 L -7.121094 73.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-280"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 92.078125 15.8125 L 68.304688 107.949219 L -10.734375 87.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-281"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.191406 -2.746094 L 45.195312 5.253906 L 33.945312 48.855469 L 2.941406 40.855469 Z M 14.191406 -2.746094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-282"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 40.308594 21.09375 C 40.445312 29.078125 34.058594 36.410156 30.335938 41.492188 C 29.574219 42.628906 29.050781 43.871094 28.769531 45.210938 C 27.628906 45.597656 26.457031 45.800781 25.253906 45.816406 C 23.960938 45.835938 22.703125 45.644531 21.476562 45.246094 C 21.183594 43.875 20.640625 42.617188 19.84375 41.464844 C 16.007812 36.464844 9.53125 29.445312 9.402344 21.585938 C 9.210938 10.25 15.976562 0.953125 24.511719 0.828125 C 33.046875 0.707031 40.109375 9.761719 40.308594 21.09375 Z M 40.308594 21.09375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-283"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 32 25 L 41 25 L 41 32 L 32 32 Z M 32 25 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-284"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 52.332031 5.554688 L 32.171875 83.691406 L -7.121094 73.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-285"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 92.078125 15.8125 L 68.304688 107.949219 L -10.734375 87.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-286"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.191406 -2.746094 L 45.195312 5.253906 L 33.945312 48.855469 L 2.941406 40.855469 Z M 14.191406 -2.746094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-287"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 40.308594 21.09375 C 40.445312 29.078125 34.058594 36.410156 30.335938 41.492188 C 29.574219 42.628906 29.050781 43.871094 28.769531 45.210938 C 27.628906 45.597656 26.457031 45.800781 25.253906 45.816406 C 23.960938 45.835938 22.703125 45.644531 21.476562 45.246094 C 21.183594 43.875 20.640625 42.617188 19.84375 41.464844 C 16.007812 36.464844 9.53125 29.445312 9.402344 21.585938 C 9.210938 10.25 15.976562 0.953125 24.511719 0.828125 C 33.046875 0.707031 40.109375 9.761719 40.308594 21.09375 Z M 40.308594 21.09375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-288"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 38 25 L 41 25 L 41 32 L 38 32 Z M 38 25 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-289"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 52.332031 5.554688 L 32.171875 83.691406 L -7.121094 73.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-290"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 92.078125 15.8125 L 68.304688 107.949219 L -10.734375 87.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-291"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.191406 -2.746094 L 45.195312 5.253906 L 33.945312 48.855469 L 2.941406 40.855469 Z M 14.191406 -2.746094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-292"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 40.308594 21.09375 C 40.445312 29.078125 34.058594 36.410156 30.335938 41.492188 C 29.574219 42.628906 29.050781 43.871094 28.769531 45.210938 C 27.628906 45.597656 26.457031 45.800781 25.253906 45.816406 C 23.960938 45.835938 22.703125 45.644531 21.476562 45.246094 C 21.183594 43.875 20.640625 42.617188 19.84375 41.464844 C 16.007812 36.464844 9.53125 29.445312 9.402344 21.585938 C 9.210938 10.25 15.976562 0.953125 24.511719 0.828125 C 33.046875 0.707031 40.109375 9.761719 40.308594 21.09375 Z M 40.308594 21.09375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-293"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13 44 L 35 44 L 35 81 L 13 81 Z M 13 44 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-294"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 52.332031 5.554688 L 32.171875 83.691406 L -7.121094 73.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-295"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.039062 -4.582031 L 92.078125 15.8125 L 68.304688 107.949219 L -10.734375 87.554688 Z M 13.039062 -4.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-remove-color)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -8.25,
    width: 99,
    fill: "rgb(0%, 0%, 0%)",
    y: -8.25,
    height: 98.999997,
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-296"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8 1 L 14 1 L 14 36 L 8 36 Z M 8 1 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-297"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.0390625 -48.582031 L 39.332031 -38.445312 L 19.171875 39.691406 L -20.121094 29.554688 Z M 0.0390625 -48.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-298"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.0390625 -48.582031 L 79.078125 -28.1875 L 55.304688 63.949219 L -23.734375 43.554688 Z M 0.0390625 -48.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-299"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 22,
    y: 0,
    height: 37
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(81.959534%, 52.549744%, 23.139954%)",
    d: "M 63.539062 99.453125 C 74.839844 98.679688 83.734375 92.097656 83.152344 83.582031 C 82.570312 75.0625 72.941406 68.785156 61.636719 69.550781 C 53.78125 70.085938 47.113281 76.902344 42.308594 80.980469 C 40.148438 82.824219 35.3125 83.972656 27.519531 84.644531 C 22.769531 85.046875 8.050781 84.355469 8.050781 84.355469 C 5.054688 84.558594 2.753906 86.648438 2.917969 89.023438 C 3.078125 91.394531 5.625 93.128906 8.636719 92.957031 C 8.636719 92.957031 22.660156 90.316406 27.363281 89.898438 C 35.007812 89.222656 40.269531 89.777344 42.84375 91.460938 C 48.121094 94.9375 55.5625 99.972656 63.539062 99.453125 Z M 63.539062 99.453125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-6)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(76.469421%, 58.428955%, 27.839661%)",
    d: "M 63.5 100.402344 C 74.800781 99.632812 83.492188 92.109375 82.917969 83.589844 C 82.339844 75.070312 72.695312 68.792969 61.398438 69.5625 C 53.542969 70.097656 46.875 76.910156 42.066406 80.992188 C 39.910156 82.835938 35.070312 83.984375 27.277344 84.65625 C 22.535156 85.054688 7.8125 84.363281 7.8125 84.363281 C 4.8125 84.570312 2.515625 86.65625 2.679688 89.03125 C 2.84375 91.40625 5.398438 93.171875 8.398438 92.964844 C 8.398438 92.964844 22.421875 90.324219 27.121094 89.910156 C 34.769531 89.234375 40.03125 89.785156 42.597656 91.472656 C 47.863281 94.953125 55.519531 100.953125 63.5 100.402344 Z M 63.5 100.402344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0%, 0%, 0%)",
    d: "M 63.5 100.402344 C 55.527344 100.839844 47.878906 94.949219 42.605469 91.488281 C 41.429688 90.785156 40.167969 90.328125 38.8125 90.113281 C 38.367188 89 38.105469 87.839844 38.027344 86.644531 C 37.933594 85.347656 38.058594 84.074219 38.398438 82.820312 C 39.742188 82.453125 40.964844 81.847656 42.066406 80.996094 C 46.859375 76.90625 53.542969 70.164062 61.398438 69.566406 C 72.984375 68.652344 82.320312 75.085938 82.917969 83.59375 C 83.515625 92.105469 75.164062 99.773438 63.5 100.402344 Z M 63.5 100.402344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-8)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-9)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-10)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-11)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-12)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 83.529663%, 19.999695%)",
    d: "M 73.375 56.027344 L 81.234375 55.496094 L 85.179688 113.21875 L 77.320312 113.753906 Z M 73.375 56.027344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-13)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-14)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-15)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-16)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-17)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 83.529663%, 19.999695%)",
    d: "M 56.984375 57.144531 L 64.847656 56.609375 L 68.789062 114.332031 L 60.929688 114.867188 Z M 56.984375 57.144531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-18)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-19)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-20)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-21)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-22)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 83.529663%, 19.999695%)",
    d: "M 40.59375 58.265625 L 48.453125 57.730469 L 52.398438 115.453125 L 44.539062 115.988281 Z M 40.59375 58.265625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-23)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-24)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-25)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-26)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-27)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 83.529663%, 19.999695%)",
    d: "M 67.445312 75.433594 L 66.957031 67.960938 L 73.683594 71.285156 Z M 67.851562 69.296875 L 68.160156 73.992188 L 72.070312 71.382812 Z M 67.851562 69.296875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-28)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-29)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-30)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-31)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-32)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 83.529663%, 19.999695%)",
    d: "M 67.886719 81.511719 L 67.394531 74.035156 L 74.121094 77.355469 Z M 68.292969 75.371094 L 68.597656 80.066406 L 72.507812 77.457031 Z M 68.292969 75.371094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-33)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-34)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-35)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-36)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-37)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 83.529663%, 19.999695%)",
    d: "M 68.296875 87.582031 L 67.804688 80.109375 L 74.527344 83.433594 Z M 68.703125 81.445312 L 69.007812 86.144531 L 72.925781 83.527344 Z M 68.703125 81.445312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-38)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-39)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-40)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-41)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-42)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 83.529663%, 19.999695%)",
    d: "M 51.304688 76.519531 L 50.820312 69.050781 L 57.539062 72.375 Z M 51.703125 70.375 L 52.007812 75.074219 L 55.925781 72.457031 Z M 51.703125 70.375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-43)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-44)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-45)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-46)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-47)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 83.529663%, 19.999695%)",
    d: "M 51.722656 82.609375 L 51.230469 75.132812 L 57.949219 78.457031 Z M 52.125 76.46875 L 52.433594 81.164062 L 56.34375 78.554688 Z M 52.125 76.46875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-48)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-49)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-50)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-51)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-52)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 83.529663%, 19.999695%)",
    d: "M 52.132812 88.691406 L 51.644531 81.21875 L 58.367188 84.542969 Z M 52.542969 82.554688 L 52.847656 87.25 L 56.757812 84.640625 Z M 52.542969 82.554688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-53)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-54)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-55)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 2, 71)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "source-5",
    clipPath: "url(#clip-59)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-56)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-57)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-58)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0%, 0%, 0%)",
    d: "M 36.640625 11.820312 C 29.902344 13.503906 23.066406 14.132812 16.132812 13.710938 C 13.855469 13.558594 11.414062 13.796875 8.945312 13.484375 C 8.945312 13.484375 0.917969 12.152344 2.550781 17.6875 C 2.550781 17.6875 4.515625 18.886719 8.609375 18.203125 C 8.609375 18.203125 27.882812 16.152344 36.257812 15.039062 C 36.257812 15.039062 36.261719 13.824219 36.296875 13.429688 C 36.332031 13.039062 36.640625 11.820312 36.640625 11.820312 Z M 36.640625 11.820312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-60)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-61)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-62)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(81.959534%, 52.549744%, 23.139954%)",
    d: "M 67.066406 48.152344 C 75.503906 40.585938 78.460938 29.925781 72.765625 23.570312 C 67.074219 17.210938 55.601562 18.164062 47.1875 25.742188 C 41.316406 30.996094 40.257812 40.480469 39 46.652344 C 38.433594 49.429688 35.320312 53.332031 29.597656 58.636719 C 26.097656 61.894531 14.046875 70.40625 14.046875 70.40625 C 11.816406 72.410156 11.289062 75.46875 12.878906 77.242188 C 14.46875 79.015625 17.566406 78.828125 19.804688 76.828125 C 19.804688 76.828125 29.230469 66.117188 32.683594 62.898438 C 38.304688 57.675781 42.78125 54.847656 45.847656 54.605469 C 52.136719 54.078125 61.121094 53.480469 67.066406 48.152344 Z M 67.066406 48.152344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-63)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-64)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-65)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-66)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-67)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(76.469421%, 58.428955%, 27.839661%)",
    d: "M 67.601562 48.945312 C 76.039062 41.386719 78.230469 30.113281 72.5625 23.742188 C 66.890625 17.375 55.394531 18.339844 46.984375 25.917969 C 41.113281 31.175781 40.050781 40.660156 38.789062 46.835938 C 38.222656 49.613281 35.113281 53.511719 29.390625 58.820312 C 25.894531 62.0625 13.863281 70.570312 13.863281 70.570312 C 11.628906 72.574219 11.105469 75.640625 12.695312 77.40625 C 14.285156 79.175781 17.378906 78.992188 19.617188 76.996094 C 19.617188 76.996094 29.050781 66.285156 32.5 63.0625 C 38.121094 57.84375 42.59375 55.011719 45.664062 54.769531 C 51.945312 54.246094 61.671875 54.269531 67.601562 48.945312 Z M 67.601562 48.945312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0%, 0%, 0%)",
    d: "M 67.601562 48.945312 C 61.585938 54.199219 51.929688 54.253906 45.65625 54.769531 C 44.296875 54.941406 43.015625 55.359375 41.816406 56.023438 C 40.742188 55.390625 39.792969 54.601562 38.972656 53.664062 C 38.148438 52.726562 37.496094 51.679688 37.011719 50.53125 C 37.855469 49.414062 38.453125 48.179688 38.804688 46.828125 C 40.066406 40.652344 41.183594 31.21875 46.996094 25.910156 C 55.582031 18.0625 66.886719 17.375 72.578125 23.734375 C 78.265625 30.097656 76.429688 41.253906 67.601562 48.945312 Z M 67.601562 48.945312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-68)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-69)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-70)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-71)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-72)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 83.529663%, 19.999695%)",
    d: "M 53.984375 2.601562 L 92.585938 45.695312 L 86.71875 50.953125 L 48.117188 7.859375 Z M 53.984375 2.601562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-73)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-74)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-75)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-76)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-77)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 83.529663%, 19.999695%)",
    d: "M 41.746094 13.566406 L 80.359375 56.65625 L 74.492188 61.914062 L 35.878906 18.824219 Z M 41.746094 13.566406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-78)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-79)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-80)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-81)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-82)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 83.529663%, 19.999695%)",
    d: "M 29.523438 24.53125 L 68.136719 67.621094 L 62.269531 72.878906 L 23.65625 29.792969 Z M 29.523438 24.53125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-83)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-84)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-85)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-86)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-87)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 83.529663%, 19.999695%)",
    d: "M 71.527344 20.511719 L 66.542969 14.917969 L 73.871094 13.398438 Z M 68.066406 15.421875 L 71.195312 18.9375 L 72.683594 14.480469 Z M 68.066406 15.421875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-88)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-89)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-90)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-91)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-92)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 83.529663%, 19.999695%)",
    d: "M 75.589844 25.054688 L 70.613281 19.457031 L 77.9375 17.929688 Z M 72.136719 19.960938 L 75.277344 23.496094 L 76.746094 19.007812 Z M 72.136719 19.960938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-93)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-94)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-95)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-96)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-97)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 83.529663%, 19.999695%)",
    d: "M 79.660156 29.597656 L 74.679688 24 L 82.011719 22.484375 Z M 76.207031 24.507812 L 79.339844 28.023438 L 80.808594 23.550781 Z M 76.207031 24.507812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-98)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-99)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-100)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-101)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-102)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 83.529663%, 19.999695%)",
    d: "M 55.371094 26.789062 L 50.40625 21.1875 L 57.734375 19.671875 Z M 51.933594 21.699219 L 55.058594 25.210938 L 56.539062 20.738281 Z M 51.933594 21.699219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-103)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-104)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-105)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-106)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-107)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 83.529663%, 19.999695%)",
    d: "M 59.449219 31.332031 L 54.472656 25.730469 L 61.808594 24.21875 Z M 56 26.238281 L 59.128906 29.75 L 60.609375 25.28125 Z M 56 26.238281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-108)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-109)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-110)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-111)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-112)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 83.529663%, 19.999695%)",
    d: "M 63.523438 35.871094 L 58.542969 30.273438 L 65.882812 28.773438 Z M 60.070312 30.777344 L 63.203125 34.296875 L 64.675781 29.828125 Z M 60.070312 30.777344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-113)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-114)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-115)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-116)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-117)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 83.529663%, 19.999695%)",
    d: "M 67.597656 40.40625 L 62.613281 34.820312 L 69.945312 33.300781 Z M 64.136719 35.320312 L 67.269531 38.835938 L 68.746094 34.371094 Z M 64.136719 35.320312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-118)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-119)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-120)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-121)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-122)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 83.529663%, 19.999695%)",
    d: "M 71.671875 44.945312 L 66.683594 39.359375 L 74.015625 37.839844 Z M 68.210938 39.859375 L 71.339844 43.378906 L 72.816406 38.910156 Z M 68.210938 39.859375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-123)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-124)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-125)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-126)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-127)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 83.529663%, 19.999695%)",
    d: "M 75.75 49.488281 L 70.765625 43.925781 L 78.097656 42.40625 Z M 72.269531 44.390625 L 75.394531 47.902344 L 76.875 43.429688 Z M 72.269531 44.390625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-128)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-129)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-130)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-131)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-132)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 83.529663%, 19.999695%)",
    d: "M 43.324219 37.597656 L 38.339844 32.003906 L 45.671875 30.492188 Z M 39.867188 32.511719 L 43 36.023438 L 44.46875 31.542969 Z M 39.867188 32.511719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-133)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-134)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-135)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-136)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-137)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 83.529663%, 19.999695%)",
    d: "M 47.390625 42.140625 L 42.40625 36.550781 L 49.742188 35.03125 Z M 43.933594 37.050781 L 47.070312 40.554688 L 48.542969 36.085938 Z M 43.933594 37.050781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-138)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-139)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-140)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-141)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-142)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 83.529663%, 19.999695%)",
    d: "M 51.464844 46.683594 L 46.476562 41.089844 L 53.808594 39.570312 Z M 48.003906 41.59375 L 51.148438 45.101562 L 52.625 40.632812 Z M 48.003906 41.59375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-143)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-144)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-145)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-146)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-147)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 83.529663%, 19.999695%)",
    d: "M 55.53125 51.222656 L 50.546875 45.632812 L 57.878906 44.113281 Z M 52.078125 46.136719 L 55.222656 49.640625 L 56.699219 45.171875 Z M 52.078125 46.136719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-148)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-149)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-150)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-151)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-152)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 83.529663%, 19.999695%)",
    d: "M 59.597656 55.769531 L 54.617188 50.171875 L 61.953125 48.660156 Z M 56.140625 50.679688 L 59.273438 54.191406 L 60.726562 49.742188 Z M 56.140625 50.679688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-153)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-154)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-155)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-156)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-157)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 83.529663%, 19.999695%)",
    d: "M 63.667969 60.308594 L 58.6875 54.714844 L 66.023438 53.199219 Z M 60.222656 55.230469 L 63.351562 58.746094 L 64.800781 54.273438 Z M 60.222656 55.230469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-158)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-159)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-160)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 7, 49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "source-8",
    clipPath: "url(#clip-164)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-161)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-162)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-163)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0%, 0%, 0%)",
    d: "M 30.214844 1.359375 C 25.9375 6.839844 20.933594 11.546875 15.207031 15.488281 C 13.320312 16.765625 11.535156 18.460938 9.402344 19.734375 C 9.402344 19.734375 2.25 23.625 6.960938 27.007812 C 6.960938 27.007812 9.253906 26.742188 12.054688 23.6875 C 12.054688 23.6875 25.988281 10.207031 31.902344 4.175781 C 31.902344 4.175781 31.15625 3.25 30.941406 2.886719 C 30.726562 2.527344 30.214844 1.359375 30.214844 1.359375 Z M 30.214844 1.359375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))))))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-165)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-166)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-167)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(81.959534%, 52.549744%, 23.139954%)",
    d: "M 75.816406 57.507812 C 82.632812 48.457031 83.484375 37.425781 76.664062 32.289062 C 69.847656 27.152344 58.796875 30.316406 51.972656 39.363281 C 47.234375 45.648438 48.015625 55.152344 47.953125 61.457031 C 47.933594 64.296875 45.636719 68.703125 41.039062 75.03125 C 38.234375 78.882812 28.070312 89.558594 28.070312 89.558594 C 26.261719 91.953125 26.335938 95.058594 28.234375 96.492188 C 30.136719 97.921875 33.113281 97.132812 34.953125 94.746094 C 34.953125 94.746094 42.140625 82.417969 44.90625 78.589844 C 49.402344 72.371094 53.265625 68.753906 56.222656 67.914062 C 62.304688 66.203125 70.988281 63.875 75.816406 57.507812 Z M 75.816406 57.507812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-168)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-169)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-170)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-171)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-172)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(76.469421%, 58.428955%, 27.839661%)",
    d: "M 76.511719 58.15625 C 83.328125 49.113281 83.335938 37.617188 76.515625 32.472656 C 69.699219 27.332031 58.640625 30.507812 51.824219 39.550781 C 47.085938 45.835938 47.867188 55.339844 47.804688 61.648438 C 47.78125 64.484375 45.484375 68.894531 40.886719 75.21875 C 38.082031 79.070312 27.921875 89.742188 27.921875 89.742188 C 26.113281 92.144531 26.1875 95.246094 28.085938 96.675781 C 29.988281 98.109375 32.996094 97.332031 34.804688 94.929688 C 34.804688 94.929688 41.992188 82.605469 44.757812 78.777344 C 49.253906 72.554688 53.117188 68.941406 56.074219 68.105469 C 62.152344 66.410156 71.699219 64.550781 76.511719 58.15625 Z M 76.511719 58.15625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-173)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-174)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-175)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-176)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-177)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0%, 0%, 0%)",
    d: "M 76.511719 58.15625 C 71.621094 64.46875 62.15625 66.390625 56.089844 68.109375 C 54.789062 68.539062 53.613281 69.191406 52.566406 70.078125 C 51.433594 69.683594 50.386719 69.125 49.429688 68.398438 C 48.390625 67.621094 47.507812 66.691406 46.785156 65.613281 C 47.386719 64.359375 47.726562 63.039062 47.808594 61.648438 C 47.855469 55.347656 47.132812 45.882812 51.828125 39.550781 C 58.726562 30.199219 69.699219 27.355469 76.523438 32.476562 C 83.34375 37.597656 83.671875 48.933594 76.511719 58.15625 Z M 76.511719 58.15625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-178)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-179)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-180)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-181)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-182)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 83.529663%, 19.999695%)",
    d: "M 49.441406 21.636719 L 54.183594 15.347656 L 100.390625 50.164062 L 95.648438 56.457031 Z M 49.441406 21.636719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-183)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-184)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-185)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-186)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-187)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 83.529663%, 19.999695%)",
    d: "M 39.550781 34.753906 L 44.292969 28.460938 L 90.5 63.28125 L 85.757812 69.570312 Z M 39.550781 34.753906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-188)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-189)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-190)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-191)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-192)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 83.529663%, 19.999695%)",
    d: "M 29.664062 47.875 L 34.40625 41.585938 L 80.613281 76.40625 L 75.871094 82.695312 Z M 29.664062 47.875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-193)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-194)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-195)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-196)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-197)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 83.529663%, 19.999695%)",
    d: "M 50.472656 51.734375 L 44.511719 47.210938 L 51.425781 44.308594 Z M 46.089844 47.410156 L 49.839844 50.253906 L 50.429688 45.582031 Z M 46.089844 47.410156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-198)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-199)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-200)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-201)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-202)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 83.529663%, 19.999695%)",
    d: "M 55.347656 55.40625 L 49.375 50.878906 L 56.289062 47.980469 Z M 50.972656 51.078125 L 54.722656 53.925781 L 55.308594 49.257812 Z M 50.972656 51.078125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-203)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-204)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-205)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 26, 61)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "source-11",
    clipPath: "url(#clip-209)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-206)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-207)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-208)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 100%, 100%)",
    d: "M 20.945312 4.433594 C 17.800781 10.625 13.800781 16.203125 8.941406 21.167969 C 7.335938 22.789062 5.914062 24.792969 4.0625 26.453125 C 4.0625 26.453125 -2.199219 31.648438 3.054688 34.039062 C 3.054688 34.039062 5.246094 33.339844 7.410156 29.796875 C 7.410156 29.796875 18.480469 13.886719 23.125 6.828125 C 23.125 6.828125 22.207031 6.03125 21.933594 5.746094 C 21.660156 5.460938 20.945312 4.433594 20.945312 4.433594 Z M 20.945312 4.433594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))))))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-210)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-211)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-212)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(81.959534%, 52.549744%, 23.139954%)",
    d: "M 39.355469 21.246094 C 39.160156 9.914062 33.042969 0.699219 24.507812 0.839844 C 15.976562 0.980469 9.183594 10.273438 9.402344 21.59375 C 9.527344 29.472656 16 36.480469 19.84375 41.472656 C 21.570312 43.722656 22.480469 48.632812 22.742188 56.429688 C 22.910156 61.207031 21.457031 75.886719 21.457031 75.886719 C 21.507812 78.886719 23.476562 81.289062 25.855469 81.25 C 28.238281 81.207031 30.125 78.746094 30.082031 75.742188 C 30.082031 75.742188 28.15625 61.605469 27.984375 56.886719 C 27.71875 49.222656 28.511719 43.984375 30.335938 41.507812 C 34.058594 36.410156 39.488281 29.230469 39.355469 21.246094 Z M 39.355469 21.246094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-213)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-214)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-215)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-216)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-217)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(76.469421%, 58.428955%, 27.839661%)",
    d: "M 40.304688 21.359375 C 40.117188 10.035156 33.035156 0.996094 24.507812 1.109375 C 15.980469 1.222656 9.179688 10.546875 9.398438 21.863281 C 9.53125 29.742188 16.003906 36.757812 19.84375 41.753906 C 21.570312 44.003906 22.480469 48.90625 22.746094 56.707031 C 22.90625 61.472656 21.460938 76.136719 21.460938 76.136719 C 21.507812 79.136719 23.484375 81.539062 25.859375 81.496094 C 28.238281 81.453125 30.128906 78.996094 30.082031 75.996094 C 30.082031 75.996094 28.164062 61.851562 27.988281 57.132812 C 27.722656 49.46875 28.515625 44.230469 30.339844 41.757812 C 34.058594 36.664062 40.445312 29.332031 40.304688 21.359375 Z M 40.304688 21.359375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0%, 0%, 0%)",
    d: "M 40.304688 21.359375 C 40.335938 29.347656 34.054688 36.679688 30.335938 41.761719 C 29.574219 42.902344 29.050781 44.144531 28.769531 45.484375 C 27.585938 45.882812 26.371094 46.082031 25.121094 46.089844 C 23.875 46.09375 22.660156 45.90625 21.472656 45.519531 C 21.179688 44.152344 20.640625 42.890625 19.847656 41.738281 C 16.007812 36.742188 9.609375 29.71875 9.402344 21.847656 C 9.09375 10.222656 15.976562 1.226562 24.511719 1.09375 C 33.042969 0.957031 40.273438 9.652344 40.304688 21.359375 Z M 40.304688 21.359375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-218)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-219)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-220)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-221)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-222)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 83.529663%, 19.999695%)",
    d: "M -3.636719 1.304688 L 54.207031 0.351562 L 54.339844 8.226562 L -3.507812 9.183594 Z M -3.636719 1.304688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-223)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-224)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-225)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-226)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-227)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 83.529663%, 19.999695%)",
    d: "M -3.363281 17.734375 L 54.488281 16.769531 L 54.621094 24.644531 L -3.230469 25.613281 Z M -3.363281 17.734375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-228)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-229)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-230)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-231)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-232)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 83.529663%, 19.999695%)",
    d: "M -3.082031 34.152344 L 54.769531 33.1875 L 54.902344 41.0625 L -2.949219 42.03125 Z M -3.082031 34.152344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-233)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-234)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-235)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-236)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-237)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 83.529663%, 19.999695%)",
    d: "M 15.550781 16.09375 L 8.066406 16.179688 L 11.71875 9.648438 Z M 9.449219 15.359375 L 14.152344 15.296875 L 11.746094 11.25 Z M 9.449219 15.359375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-238)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-239)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-240)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-241)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-242)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 83.529663%, 19.999695%)",
    d: "M 21.652344 15.988281 L 14.164062 16.082031 L 17.824219 9.546875 Z M 15.546875 15.257812 L 20.25 15.195312 L 17.839844 11.148438 Z M 15.546875 15.257812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-243)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-244)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-245)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-246)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-247)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 83.529663%, 19.999695%)",
    d: "M 27.753906 15.878906 L 20.261719 15.980469 L 23.933594 9.449219 Z M 21.644531 15.15625 L 26.351562 15.09375 L 23.941406 11.054688 Z M 21.644531 15.15625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-248)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-249)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-250)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-251)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-252)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 83.529663%, 19.999695%)",
    d: "M 33.851562 15.773438 L 26.363281 15.878906 L 30.015625 9.34375 Z M 27.738281 15.058594 L 32.449219 14.992188 L 30.039062 10.953125 Z M 27.738281 15.058594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-253)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-254)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-255)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-256)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-257)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 83.529663%, 19.999695%)",
    d: "M 39.949219 15.664062 L 32.457031 15.777344 L 36.113281 9.242188 Z M 33.835938 14.953125 L 38.546875 14.890625 L 36.136719 10.847656 Z M 33.835938 14.953125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-258)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-259)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-260)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-261)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-262)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 83.529663%, 19.999695%)",
    d: "M 46.050781 15.558594 L 38.582031 15.683594 L 42.234375 9.144531 Z M 39.917969 14.851562 L 44.621094 14.785156 L 42.210938 10.742188 Z M 39.917969 14.851562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-263)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-264)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-265)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-266)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-267)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 83.529663%, 19.999695%)",
    d: "M 15.832031 32.28125 L 8.339844 32.382812 L 11.996094 25.851562 Z M 9.722656 31.5625 L 14.429688 31.492188 L 12.003906 27.449219 Z M 9.722656 31.5625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-268)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-269)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-270)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-271)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-272)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 83.529663%, 19.999695%)",
    d: "M 21.925781 32.179688 L 14.4375 32.285156 L 18.09375 25.75 Z M 15.816406 31.460938 L 20.519531 31.382812 L 18.109375 27.34375 Z M 15.816406 31.460938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-273)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-274)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-275)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-276)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-277)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 83.529663%, 19.999695%)",
    d: "M 28.027344 32.078125 L 20.535156 32.183594 L 24.191406 25.644531 Z M 21.914062 31.355469 L 26.625 31.277344 L 24.214844 27.238281 Z M 21.914062 31.355469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-278)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-279)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-280)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-281)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-282)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 83.529663%, 19.999695%)",
    d: "M 34.121094 31.972656 L 26.632812 32.082031 L 30.285156 25.542969 Z M 28.015625 31.257812 L 32.722656 31.171875 L 30.3125 27.132812 Z M 28.015625 31.257812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-283)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-284)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-285)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-286)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-287)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 83.529663%, 19.999695%)",
    d: "M 40.222656 31.878906 L 32.730469 31.980469 L 36.386719 25.441406 Z M 34.113281 31.160156 L 38.816406 31.089844 L 36.402344 27.078125 Z M 34.113281 31.160156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-288)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-289)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-290)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-291)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-292)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 83.529663%, 19.999695%)",
    d: "M 46.316406 31.777344 L 38.824219 31.875 L 42.484375 25.339844 Z M 40.21875 31.054688 L 44.929688 30.992188 L 42.496094 26.96875 Z M 40.21875 31.054688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-293)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-294)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-295)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 13, 44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "source-14",
    clipPath: "url(#clip-299)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-296)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-297)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-298)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(100%, 100%, 100%)",
    d: "M 8.472656 1.25 C 9.8125 8.074219 10.097656 14.9375 9.324219 21.847656 C 9.054688 24.109375 9.167969 26.570312 8.734375 29.011719 C 8.734375 29.011719 6.988281 36.96875 12.632812 35.621094 C 12.632812 35.621094 13.929688 33.714844 13.457031 29.597656 C 13.457031 29.597656 12.394531 10.242188 11.707031 1.820312 C 11.707031 1.820312 10.519531 1.777344 10.105469 1.707031 C 9.691406 1.632812 8.472656 1.25 8.472656 1.25 Z M 8.472656 1.25 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYurumeifavicon);
export default __webpack_public_path__ + "static/media/yurumeifavicon.e076f8c3875c9d971ca78135ad96f75a.svg";
export { ForwardRef as ReactComponent };